import React from 'react';
import { Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';

export const PROVISIONING_STATUS_CHOICES = [
  { id: 'pending', name: 'Pending' },
  { id: 'succeeded', name: 'Succeeded' },
  { id: 'failed', name: 'Failed' },
];

const FRESHNESS_LABELS = { current: 'Current', stale: 'Stale' };

type ProvisioningReportFieldProps = { label?: string; sortable?: boolean };

// Both fields null means no report was received; undefined means they were not permitted
const ProvisioningReportField = (props: ProvisioningReportFieldProps) => {
  const record = useRecordContext(props);
  const status = record?.provisioning_status;
  const freshness = record?.provisioning_freshness;

  if (status === undefined && freshness === undefined) {
    return null;
  }

  const statusLabel = PROVISIONING_STATUS_CHOICES.find(({ id }) => id === status)?.name ?? status;
  const text =
    status === null && freshness === null
      ? 'No report'
      : [statusLabel, FRESHNESS_LABELS[freshness]].filter(Boolean).join(' · ');

  return (
    <Typography component="span" variant="body2" data-testid="provisioning-report-field">
      {text}
    </Typography>
  );
};

export default ProvisioningReportField;
